<template>
  <div
    :class="{
      'fi-grid': true,
      [getColumns]: true,
      [gridBaseClass]: true,
      [gridClass || '']: gridClass,
      'grid-columns-fi--container': container,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({
  name: 'GridColumnsFi',
});

const props = withDefaults(
  defineProps<{
    columns?: number;
    gridClass?: string | null;
    gridBaseClass?: string;
    container?: boolean;
  }>(),
  {
    columns: 12,
    gridClass: null,
    gridBaseClass: 'fi-gap-small md:fi-gap-large',
  },
);

const getColumns = computed<string>(() => `fi-grid-cols-${props.columns}`);
</script>

<style scoped src="./grid-columns-fi" />
